// extracted by mini-css-extract-plugin
module.exports = {"rightAnswerIcon":"RightAnswerDialog_rightAnswerIcon__2mxkN","rightAnswerIconVisibled":"RightAnswerDialog_rightAnswerIconVisibled__1tt7q"};